<div tabindex="-1" role="dialog">
  <div class="modal-container">
    <div class="modal-header" #modalHeaderRef>
      <div>{{ title }}</div>
      @if (showDownloadingMsg$ | async) {
        <span> Downloading... </span>
      }
      @if ((showDownloadingMsg$ | async) === false) {
        <span (click)="downloadImage()" class="download-button" ngbTooltip="Export image" placement="top" download>
          <grid-ui-icon class="icon" name="download" data-testid="icon-download"></grid-ui-icon>
        </span>
      }
      <span (click)="close()" class="close-button" ngbTooltip="Close window" placement="top">
        <grid-ui-icon class="icon" name="cross" data-testid="icon-close-modal"></grid-ui-icon>
      </span>
    </div>

    <div class="modal-body">
      <div #subTitleRef>
        @if (subtitle) {
          <h5 class="image-sub-header">{{ subtitle }}</h5>
        }
      </div>
      <div>
        <img class="img-fluid mx-auto d-block" [src]="url | imageResizer" [alt]="alt_text" (contextmenu)="disableRightClick($event)" />
      </div>
    </div>

    <div class="divider"></div>

    <div class="modal-footer" #modalFooterRef>
      <div class="footer-logo-attribution d-flex flex-row justify-content-between">
        <img class="vm-logo align-self-start m-2" src="assets/img/vm-logo-tm.png" alt="vm logo" />
        @if (attribution || caption) {
          <span class="attribution-text align-self-center m-2">
            @if (caption) {
              <span>{{ caption }}</span>
            }
            @if (attribution) {
              <span>Source: {{ attribution }}</span>
            }
          </span>
        }
      </div>
    </div>
  </div>
</div>

<div class="offscreen" tabindex="-1">
  <div #offscreenContainerRef></div>
</div>
